const Loader = function() {

    const duration = 900; // Change the duration of the animation

    const c = document.querySelector('.js-loader');
    const ctx = c.getContext('2d');
    const img = new Image();

    // Proper scaling for retina
    const pixelRatio = window.devicePixelRatio || 1;
    c.width = 300 * pixelRatio;
    c.height = 150 * pixelRatio;
    ctx.scale(pixelRatio, pixelRatio);

    let progress = 0;
    let startTime = null;
    let play = false;
    let ready = false;

    const _draw = () => {
        const now = performance.now();

        if (!startTime) {
            startTime = now;
        }

        progress = (now - startTime) / duration;
        if (progress > 1) {
            progress = 1;
        }

        ctx.save();
        ctx.clearRect(0, 0, 300, 150);

        ctx.drawImage(img, 150 - 26.865, 75 - 37.5, 53.73, 75);

        ctx.globalCompositeOperation = 'source-atop';

        // Render the dark circle
        const circleDarkPos = _lerp([0, 210], [300, 160], progress);
        ctx.beginPath();
        ctx.arc(circleDarkPos[0], circleDarkPos[1], 100, 0, 2 * Math.PI);
        ctx.fillStyle = '#8B5CDD';
        ctx.fill();

        // Render the light circle
        const circleLightPos = _lerp([300, -20], [0, 0], progress);
        ctx.beginPath();
        ctx.arc(circleLightPos[0], circleLightPos[1], 75, 0, 2 * Math.PI);
        ctx.fillStyle = '#D1BEF1';
        ctx.fill();

        ctx.restore();

        // If animation has completed, reset
        if (progress >= 1) {
            startTime = null;
            progress = 0;
        }

        // Check animation is still meant to be playing before drawing the next frame
        if (play) {
            requestAnimationFrame(_draw);
        }
    };

    // Easing function
    const _easing = t => {
        return t*(2-t);
    };

    const _lerp = (a, b, p) => {
        const x = a[0] + (b[0] - a[0]) * _easing(p);
        const y = a[1] + (b[1] - a[1]) * _easing(p);

        return [x, y];
    };

    return {
        // Load the SVG before going into 'ready' state
        init: () => {
            img.onload = () => {
                ready = true;
            };
            img.src = parallax.pUrl;
        },

        // Play animation if ready
        start: () => {
            if (ready) {
                requestAnimationFrame(_draw);
                play = true;
            }
        },

        // Stop animation
        stop: () => {
            startTime = null;
            progress = 0;
            play = false;
        }
    }
}();

export default Loader;


// WEBPACK FOOTER //
// ./assets/js/components/_loader.js